var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconAddressNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7715 10.651L8.94275 13.31C8.81904 13.4265 8.67215 13.5188 8.51046 13.5818C8.34876 13.6448 8.17545 13.6772 8.00042 13.6772C7.82538 13.6772 7.65207 13.6448 7.49038 13.5818C7.32868 13.5188 7.18179 13.4265 7.05808 13.31L4.22875 10.651C3.4829 9.94987 2.97497 9.05653 2.76921 8.08401C2.56344 7.11151 2.66908 6.10346 3.07275 5.18738C3.47643 4.27131 4.16001 3.48832 5.03707 2.93744C5.91413 2.38656 6.94526 2.09253 8.00008 2.09253C9.0549 2.09253 10.0861 2.38656 10.9631 2.93744C11.8402 3.48832 12.5238 4.27131 12.9275 5.18738C13.3311 6.10346 13.4368 7.11151 13.231 8.08401C13.0252 9.05653 12.5173 9.94987 11.7715 10.651Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconAddressNew);
export default __webpack_public_path__ + "static/media/common_icon_address_new.82045de73fdac1e7cf48f70acea7b260.svg";
export { ForwardRef as ReactComponent };